import { Component, ElementRef, HostListener, OnInit} from '@angular/core';
import { Router, ActivatedRoute, Event as RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { AuthService } from './core/auth/auth.service';
import { LoadingIndicatorService } from './core/helpers/loading-indicator.service';
import { Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  notifyOptions = {
    position: ['top', 'right'],
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: true,
    lastOnBottom: true,
    clickToClose: true,
    maxLength: 0,
    maxStack: 8,
    preventDuplicates: true,
    preventLastDuplicates: false,
    theClass: 'the-best-on-top',
    rtl: false,
    animate: 'fromRight' // fromLeft | scale | rotate | null,
    // icons: '<i class="fa fa-fa">' html string
  };
  public loading$: Observable<boolean>;
  // example data
  appData;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private el: ElementRef,
    private auth: AuthService,
    private loadingIndicatorSerivce: LoadingIndicatorService,
  ) {
    router.events.subscribe((event: RouterEvent) => {
      // this.navigationInterceptor(event);
    });
    this.loading$ = this.loadingIndicatorSerivce.onLoadingChanged.pipe(debounceTime(100));
  }

  /**
   * TODO: Idea how hide user data and user permission from localStorage
   * @param e
   */

  @HostListener('window:load', ['$event']) load(e) {
    this.el.nativeElement.previousElementSibling.classList.add('fadeOut');
    setTimeout(() => {
      const body = this.el.nativeElement.previousElementSibling.parentElement;
      body.removeChild(this.el.nativeElement.previousElementSibling);
    }, 1000);
    /*
    console.log(e);
    alert('unload');
    // When app loaded get data from localStorage
    this.appData = JSON.parse(localStorage.getItem('time'));
    // then remove data. Data store in memory app
    localStorage.removeItem('time');*/
  }
  /*
  @HostListener('window:unload', ['$event']) unload(e) {
    console.log(e);
    // when app reload set data to localStorage
    localStorage.setItem('time', JSON.stringify(this.auth.userProfile));
  }
  */
  ngOnInit() {
    if (!this.auth.userProfile) {
      this.router.navigate(['login']);
    }
  }
  /*
  private navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading = true;
    }
    if (event instanceof NavigationEnd) {
      this.loading = false;
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loading = false;
    }
    if (event instanceof NavigationError) {
      this.loading = false;
    }
  }
  */
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts